<div class="recover-username">
  <div class="recover-username__header">
    <div class="recover-username__icon-background">
      <i class="fa-regular fa-user recover-username__icon"></i>
    </div>
    <div class="recover-username__title">{{ 'login.recovery.by-username.title' | translate }}</div>
  </div>

  <div class="recover-username__content">
    <div class="recover-username__description">{{ 'login.recovery.by-username.description' | translate }}</div>

    <div class="recover-username__input">
      <kds-input
        elementId="email"
        [label]="'login.recovery.controls.email' | translate"
        [componentFormControl]="recoveryForm.controls.userEmail"
      />
    </div>
    <div class="recover-username__input">
      <kds-input
        elementId="companyName"
        [label]="'login.recovery.controls.company-name' | translate"
        [componentFormControl]="recoveryForm.controls.organizationName"
      >
        <a kds-link kdsPrefetch [routerLink]="['/', ApplicationPath.CannotLogin, LoginRecoveryPath.ForgotCompanyName]">
          {{ 'login.recovery.by-company-name.title' | translate }}
        </a>
      </kds-input>
    </div>

    <div class="recover-username__buttons">
      <kds-large-button
        [buttonText]="'login.recovery.buttons.continue' | translate"
        [loading]="loading()"
        [disabled]="recoveryForm.invalid"
        (buttonClick)="recoverCredentials()"
      />

      <kds-large-button
        colorScheme="tertiary"
        [buttonText]="'login.recovery.buttons.back-to-login' | translate"
        (buttonClick)="backToLogin()"
      />
    </div>
  </div>
</div>
